export const AI_MODEL = {
    pendo: 'Pendo',
    google: 'Google',
    openAi: 'OpenAi',
    azureOpenAI: 'AzureOpenAI',
    claude: 'Claude',
    anthropic: 'Anthropic',
};

export const AI_MODEL_DATA = {
    [AI_MODEL.pendo]: {
        label: 'Pendo AI',
        icon: 'PendoLogoIcon',
    },
    [AI_MODEL.google]: {
        label: 'Google Generative AI',
        icon: 'GoogleCloudIcon',
    },
    [AI_MODEL.openAi]: {
        label: 'OpenAI',
        icon: 'OpenAiIcon',
    },
    [AI_MODEL.azureOpenAI]: {
        // eslint-disable-next-line internal-rules/no-hardcoded-colors
        label: 'Azure OpenAI',
        icon: 'AzureIcon',
    },
    [AI_MODEL.claude]: {
        label: 'Claude',
        icon: 'ClaudeIcon',
    },
    [AI_MODEL.anthropic]: {
        label: 'Anthropic',
        icon: 'AnthropicIcon',
    },
};
